import { useEffect } from "react";

export default function Paginate({
  nextPage,
  pageIndex,
  totalCount,
  prevPage,
  totalPages,
  setPageIndex,
}) {
  const previous = async () => {
    let previousPage = pageIndex - 1;
    if (previousPage <= 0) return;

    setPageIndex(previousPage);
  };

  const next = async () => {
    let nxtPage = pageIndex + 1;
    if (nxtPage > totalPages) return;
    setPageIndex(nxtPage);
  };

  const renderPageNumbers = () => {
    let pages = [];
    if (totalPages <= 15) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let start = Math.max(pageIndex - 2, 1);
      let end = Math.min(pageIndex + 2, totalPages);

      if (pageIndex > 5) {
        pages.push(1, 2, "...");
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (pageIndex < totalPages - 4) {
        pages.push("...", totalPages - 1, totalPages);
      }
    }

    return pages;
  };

  return (
    <>
      <nav
        className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6 mt-8"
        aria-label="Pagination"
      >
        <div className="sm:block">
          <p className="text-sm text-gray-700">
            Showing{" "}
            <span className="font-medium">
              {pageIndex !== 1 ? pageIndex * 10 + 1 - 10 : 1}
            </span>{" "}
            to
            <span className="mx-1 font-medium">
              {pageIndex * 10 > totalCount ? totalCount : pageIndex * 10}
            </span>
            of
            <span className="mx-1 font-medium">{totalCount}</span> result(s)
          </p>
        </div>
        <div className="flex text-center">
          <p className="text-sm text-gray-700">
            Page {pageIndex} of {totalPages}
          </p>
        </div>
        <div className="flex justify-between sm:justify-end">
          {pageIndex > 1 && (
            <button
              type="button"
              onClick={previous}
              className={
                "mr-5 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
              }
            >
              Previous
            </button>
          )}
          <div className="flex items-center space-x-1">
            {renderPageNumbers().map((page, index) =>
              page === "..." ? (
                <span key={index} className="px-2 py-1">
                  ...
                </span>
              ) : (
                <button
                  key={index}
                  type="button"
                  onClick={() => setPageIndex(page)}
                  className={`px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${
                    pageIndex === page
                      ? "text-white bg-gray-700"
                      : "text-gray-700 bg-white hover:bg-gray-50"
                  }`}
                >
                  {page}
                </button>
              ),
            )}
          </div>
          {pageIndex < totalPages && (
            <button
              type="button"
              onClick={next}
              className={
                nextPage === false
                  ? "hidden"
                  : "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
              }
            >
              Next
            </button>
          )}
        </div>
      </nav>
    </>
  );
}
